import axios from "axios";
import settings from "utils/settings";

const apiUrl = `${settings.apiUrl}api/`;

const controllerUrl = `${apiUrl}bike-scan-trigger`;

export const requestAdd = (data) =>
  axios.post(`${controllerUrl}`, data);

export const requestUpdate = (id, data) =>
  axios.put(`${controllerUrl}/${id}`, data);

export const requestGetActions = () =>
  axios.get(`${controllerUrl}/actions`);

export const requestList = (filters) =>
  axios.post(`${controllerUrl}/list`, {
    criteria: filters
  });



// WEBPACK FOOTER //
// ./src/actions/bike-scan-trigger/requests.js